module.exports = __webpack_public_path__ + "img/Bulgarian-alphabet.d6dcd1bc.png";